import { render, staticRenderFns } from "./v-range-picker.vue?vue&type=template&id=ff6b2c4c&"
import script from "./v-range-picker.vue?vue&type=script&lang=js&"
export * from "./v-range-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports